import { FILTER_PRICES, RANGE_FILTER_TYPE, RangeFacetLocal } from 'components/Filter/Filter.types';
import { getLoadedPrices } from 'domains/references';
import { GarageView, SparePartsViewType } from 'domains/user';
import { getData } from 'utils';

export const getPricesRange = (
  priceForAvailable: ReturnType<typeof getLoadedPrices>,
  sparePartsView: SparePartsViewType,
): [number, number] | undefined => {
  const pricesValues = priceForAvailable.map((priceData) => {
    const price = getData(priceData);
    return sparePartsView === GarageView
      ? Number(getData(price?.prices)?.garageView?.vatExcludedPrice ?? 0)
      : Number(getData(price?.prices)?.clientView?.recommendedPriceVatIncluded ?? 0);
  });
  const productPrices = pricesValues.filter((price) => price > 0);

  return productPrices.length > 0 ? [Math.min(...productPrices), Math.max(...productPrices)] : undefined;
};

export const createPricesFacet = (
  pricesRange: [number, number] | undefined,
  availableTiresCount: number,
): RangeFacetLocal => {
  return {
    id: FILTER_PRICES,
    type: RANGE_FILTER_TYPE,
    min: pricesRange ? pricesRange[0] : 0,
    max: pricesRange ? pricesRange[1] : 0,
    numberOfItems: availableTiresCount,
    active: true,
  };
};
